
import React from 'react';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import VideoCard from '../card/VideoCard';

export default class MediaListCardView extends React.PureComponent {
  static propTypes = {
    medias: PropTypes.arrayOf(PropTypes.shape({
      mediaId: PropTypes.string.isRequired,
      clips: PropTypes.array.isRequired,
      vehicle: PropTypes.string.isRequired,
      driver: PropTypes.string,
      date: PropTypes.number.isRequired,
      address: PropTypes.string,
      driverId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      machineType: PropTypes.number,
      terminal: PropTypes.string,
      oer: PropTypes.string,
      triggerType: PropTypes.string.isRequired,
      terminalId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    })).isRequired,
    onVideoOpen: PropTypes.func.isRequired,
    prepareReference: PropTypes.func.isRequired,
    onFlagVideo: PropTypes.func.isRequired,
    addFilterChipOnDriverClick: PropTypes.func.isRequired,
    addFilterChipOnVehicleClick: PropTypes.func.isRequired,
    addFilterChipOnTerminalClick: PropTypes.func.isRequired,
    addFilterOnOERClick: PropTypes.func.isRequired,
    addOnDemandFilter: PropTypes.func.isRequired,
    onDeleteVideo: PropTypes.func.isRequired,
    isMobile: PropTypes.bool,
    canDelete: PropTypes.bool,
    askDeleteConfirmation: PropTypes.bool,
    isInternal: PropTypes.bool,
    locale: PropTypes.string,
    videoCardWrapperComponent: PropTypes.element
  };
  static defaultProps = {
    locale: 'en',
    isMobile: false,
    canDelete: false,
    askDeleteConfirmation: true,
    isInternal: false,
    videoCardWrapperComponent: null
  }

  renderVideoCard(media, index) {
    const videoCard = (
      <VideoCard
        key={media.mediaId}
        index={index}
        media={media}
        canDelete={this.props.canDelete}
        askDeleteConfirmation={this.props.askDeleteConfirmation}
        isInternal={this.props.isInternal}
        addFilterChipOnDriverClick={this.props.addFilterChipOnDriverClick}
        addFilterChipOnVehicleClick={this.props.addFilterChipOnVehicleClick}
        addFilterChipOnTerminalClick={this.props.addFilterChipOnTerminalClick}
        addFilterOnOERClick={this.props.addFilterOnOERClick}
        addOnDemandFilter={this.props.addOnDemandFilter}
        onDeleteVideo={this.props.onDeleteVideo}
        onVideoOpen={this.props.onVideoOpen(media.mediaId)}
        ref={el => this.props.prepareReference(media, el)}
        isMobile={this.props.isMobile}
        onFlagVideo={this.props.onFlagVideo}
        locale={this.props.locale}
      />
    );

    const {videoCardWrapperComponent} = this.props;

    if (!videoCardWrapperComponent) {
      return videoCard;
    }

    return React.cloneElement(videoCardWrapperComponent, {...videoCard.props}, videoCard);
  }

  render() {
    return (
      <React.Fragment>
        {
          this.props.medias.map((media, index) => (
            <Grid item xl={2} lg={3} md={4} sm={6} xs={12} key={media.mediaId} className="library__card">
              {this.renderVideoCard(media, index)}
            </Grid>
          ))
        }
      </React.Fragment>
    );
  }
}
